import { useQuery } from '@tanstack/vue-query'

import { getOrdersList } from '../ordersEndpoints'
import { ordersQueryKeys } from '../ordersQueryKeys'

const PARAMS = { orderStatus: ['paid'], page: 1, limit: 1 }

export function useOrdersPendingApprovalCountQuery() {
  return useQuery({
    queryKey: ordersQueryKeys.pendingApprovalCount(),
    queryFn: () => getOrdersList(PARAMS).then((r) => r.pagination.totalItems),
    staleTime: 30_000,
  })
}
